"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailResetPasswordLogin = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _react = require("react");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _TagAndInput = require("../../molecules/TagAndInput");

var _GeneralButton = require("../../atoms/GeneralButton");

var _jsxRuntime = require("react/jsx-runtime");

var EmailResetPasswordLogin = function EmailResetPasswordLogin(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyEmail = _useState2[0],
      setEmptyEmail = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      invalidEmail = _useState4[0],
      setInvalidEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showErrors = _useState6[0],
      setShowErrors = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      awsError = _useState8[0],
      setAwsError = _useState8[1];

  var validate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var valid, email;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              valid = true;
              setShowErrors(true);
              e.preventDefault();
              email = document.querySelector("#emailInput").value.trim();
              email === "" ? setEmptyEmail(true) : setEmptyEmail(false);
              !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email) ? setInvalidEmail(true) : setInvalidEmail(false);
              emptyEmail && (valid = false);
              invalidEmail && (valid = false);

              if (!valid) {
                _context.next = 20;
                break;
              }

              _context.prev = 9;
              _context.next = 12;
              return props.Auth.forgotPassword(email);

            case 12:
              sessionStorage.setItem("email", JSON.stringify(email));
              sessionStorage.setItem("resetPasswordProcess", JSON.stringify("true"));
              props.setPaso(5);
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);
              setAwsError(_context.t0.code);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 17]]);
    }));

    return function validate(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "user",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "emailInput",
      label: "Nombre de usuario",
      inputPlaceHolder: "username@contentoh.com"
    }), showErrors && emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su correo"
    }), showErrors && invalidEmail && !emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese un correo valido"
    }), showErrors && awsError === "LimitExceededException" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Has cambiado la contrase\xF1a recientemente, intenta despues"
    })]
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        return validate(e);
      }
    })
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "back-login",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      onClick: function onClick() {
        return props.setPaso(7);
      },
      children: "Regresar..."
    })
  }, "5")];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
      componentsArray: loginRight,
      panelType: "home-login",
      panelColor: _variables.GlobalColors.white
    })
  });
};

exports.EmailResetPasswordLogin = EmailResetPasswordLogin;